import React, { useMemo } from 'react'
import Dialog from '@mui/material/Dialog'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { Button, Icon } from '../../../../components/UI'
import AcceptClassDetailsTutor from './AcceptClassDetailsTutor'
import AcceptClassDetailsClasses from './AcceptClassDetailsClasses'
import AcceptClassDetailsQuizzes from './AcceptClassDetailsQuizzes'

import { selectStudentCalendarData } from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { classStatuses } from '../../../../constants'
import LightTooltip from '../../../../components/UI/LightTooltip'

const AcceptClassDetails = ({
  data,
  open,
  isTimeChangeRequested,
  onClose,
  onOpenChangeTimeModal,
  onOpenCancelModal,
}) => {
  const userCalendarData = useSelector(selectStudentCalendarData)

  const timeDetector = useMemo(() => {
    // if (data && typeof data === 'object') {
    //   return data;
    // }

    const key = `${moment(data).format('YYYY-MM-DD')}:${moment(data).format('H')}`

    if (!userCalendarData[key]) {
      return null
    }

    return userCalendarData[key]
  }, [data])

  const classBanner = timeDetector?.availability_calendar_detail?.class_banner

  const statusData = classStatuses[timeDetector?.status]

  const handleChangeTime = () => {
    onClose()

    setTimeout(() => {
      onOpenChangeTimeModal(timeDetector)
    }, 300)
  }

  const handleCancelClass = () => {
    onClose()

    setTimeout(() => {
      onOpenCancelModal(data)
    }, 300)
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'relative xl:!max-w-[762px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD]',
      }}
    >
      {timeDetector && (
        <div className="w-full flex flex-col items-center justify-center">
          <div className="w-full flex relative items-center justify-center">
            <h2 className="text-2xl font-bold text-primary-100 text-center">
              {classBanner.class_banner_category.name}
            </h2>

            <button className="absolute right-0" onClick={onClose}>
              <Icon name="close" color="#F79009" className="w-[24px] h-[24px]" />
            </button>
          </div>

          {isTimeChangeRequested ? (
            <div
              className={`mt-[12px] px-[8px] h-[32px] rounded-[8px] ${classStatuses.in_review.background} flex items-center justify-center`}
            >
              <span className="text-base text-[#FDFDFD] font-bold mr-[8px]">
                You Requested to Change the Time
              </span>

              <LightTooltip
                title={<span className="inline-block w-full text-center">Text</span>}
                arrow
              >
                <div>
                  <Icon name="info" color="#FDFDFD" className="w-[24px] h-[24px]" />
                </div>
              </LightTooltip>
            </div>
          ) : (
            <span
              className={`mt-[12px] px-[8px] h-[32px] rounded-[8px] ${statusData?.background || 'bg-black'} text-base text-[#FDFDFD] font-bold flex items-center justify-center`}
            >
              {statusData?.title || timeDetector?.status}
            </span>
          )}

          <div className="w-full flex items-center justify-center gap-[24px] mt-[12px]">
            <div className="flex items-center justify-center">
              <Icon name="time-fill" color="#F79009" className="w-[24px] h-[24px] mr-[8px]" />

              <span className="text-base font-normal text-primary-100">
                {moment(data).format('dddd, MMM DD, HH:mm')}
              </span>
            </div>

            <div className="flex justify-center items-center">
              <img className="w-[24px] h-[24px]" src={'/assets/icon/euro-coin.svg'} alt="Euro" />

              <span className="font-normal ml-2 text-sm text-primary-100">
                {classBanner.price_per_class || 0}
              </span>
            </div>
          </div>

          <div className="w-full flex items-stretch justify-center gap-[8px] mt-[12px]">
            <AcceptClassDetailsQuizzes />
            <AcceptClassDetailsClasses />
            <AcceptClassDetailsTutor classBanner={classBanner} />
          </div>

          <div className="w-full flex items-center justify-center gap-[10px] mt-[12px]">
            {!isTimeChangeRequested && (
              <Button type="button" className="flex-1" onClick={handleChangeTime}>
                Change the Time
              </Button>
            )}

            <Button
              type="button"
              variant="red"
              className={`flex-1 ${isTimeChangeRequested ? 'max-w-[330px]' : ''}`}
              onClick={handleCancelClass}
            >
              Cancel this Class
            </Button>
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default AcceptClassDetails
